import { Component } from "react";

import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import PropTypes from "prop-types";
import { Scrollbars } from "react-custom-scrollbars-2";

import { Icon } from "@/shared/components/common/Icon/Icon";

import { ContextMenuItem } from "../ContextMenuItem/ContextMenuItem";

class CollapseSwitchMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleFarmClick = (id) => {
    window.location.assign(`${window.location.origin}/farm/${id}`);
  };

  render() {
    const { currentItemId, icon, items, label, mobile, switchId } = this.props;
    return (
      <div>
        <ContextMenuItem
          {...(switchId ? { id: `${switchId}-switch` } : {})}
          icon={icon}
          label={label}
          mobile={mobile}
          onClick={this.handleClick}
          extraContent={
            this.state.open ? (
              <Icon name="caret-up" size="lg" />
            ) : (
              <Icon name="caret" size="lg" />
            )
          }
        />

        <Collapse in={this.state.open} timeout="auto">
          <Scrollbars autoHeight={true} autoHeightMax={200}>
            <List component="div" disablePadding>
              {items.map((item) => (
                <ContextMenuItem
                  {...(switchId ? { id: `${switchId}-switch-${item.id}` } : {})}
                  icon={<Icon name="check" size="lg" />}
                  key={item.id}
                  label={item.name}
                  mobile={mobile}
                  onClick={() => this.props.onMenuItemClick(item.id)}
                  secondaryLevel={true}
                  iconStyle={{
                    visibility:
                      currentItemId === item.id ? "visible" : "hidden",
                  }}
                />
              ))}
            </List>
          </Scrollbars>
        </Collapse>
      </div>
    );
  }
}

CollapseSwitchMenu.propTypes = {
  currentItemId: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  icon: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  mobile: PropTypes.bool,
  switchId: PropTypes.string,
};

CollapseSwitchMenu.defaultProps = {
  switchId: "",
  icon: null,
  label: "",
  mobile: false,
};

export default CollapseSwitchMenu;
